/**
 * AppPreviewModal.jsx
 * ===================
 * Component that opens AppPreview in a new tab for the selected application
 * Used in Header and PageHeader to show app preview next to the app selector
 */

import React from 'react';

const AppPreviewModal = ({ appName, trigger }) => {
  const handlePreviewClick = () => {
    if (!appName) return;
    
    const previewUrl = `/app-preview?app=${encodeURIComponent(appName)}`;
    window.open(previewUrl, '_blank', 'noopener,noreferrer');
  };

  if (!appName) {
    return null;
  }

  return (
    <>
      {/* Trigger Button */}
      {trigger ? (
        <div onClick={handlePreviewClick} style={{ cursor: 'pointer' }}>
          {trigger}
        </div>
      ) : (
        <button
          onClick={handlePreviewClick}
          style={{
            padding: '8px 12px',
            background: 'rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '6px',
            color: '#FFFFFF',
            fontSize: '13px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            marginLeft: '12px'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.3)';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(255, 255, 255, 0.2)';
            e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          }}
          title="Preview Application in New Tab"
        >
          <span>👁️</span>
          <span>Preview</span>
        </button>
      )}
    </>
  );
};

export default AppPreviewModal;

